import React from 'react';
import * as PropTypes from 'prop-types';
import styled from 'styled-components';
import { mediaSize } from '../../styles';

import Talent from './talent';
import { AddButton, DividerS, Placeholder } from '../notes-simple-list/styles';

const ListWrap = styled.div`
  width: 100%;
  
  @media (min-width: ${mediaSize.desktop}) {
    padding: 0;
  }
`;

const TalentsList = ({
  talents,
  requestId,
  openManageTalentsModal,
  ...rest
}) => (
  <ListWrap>
    <AddButton onClick={() => openManageTalentsModal(requestId)}>
      Manage talents
    </AddButton>
    <DividerS />
    {!talents.length && <Placeholder>No talents yet...</Placeholder>}
    {talents.map((talent, index) => (
      <Talent
        {...talent}
        requestId={requestId}
        number={index + 1}
        key={talent._id}
        {...rest}
      />
    ))}
  </ListWrap>
);

TalentsList.propTypes = {
  talents: PropTypes.array.isRequired,
  requestId: PropTypes.string.isRequired,
  openManageTalentsModal: PropTypes.func.isRequired,
};


export default TalentsList;



// WEBPACK FOOTER //
// ./src/components/talents-list/index.js